import formatZonedDate from 'legacy/utils/date/formatZonedDate'

import { LATE_CHECK_IN_REASON_OPTIONS } from '../domain/LateCheckInReason'
import { type StopCheckType, type StopEvent } from '../domain/Shipment'

export type StopEventAudit = {
  completedBy?: string
  completedAt?: string
  reasonLabel?: string
  reasonNote?: string
}

export function getStopEventAudit(
  type: StopCheckType,
  event?: StopEvent,
  timezone?: string
): StopEventAudit | null {
  if (!event) return null

  const reasonLabel = LATE_CHECK_IN_REASON_OPTIONS.find(
    option => option.value === event.reasonCode
  )?.label
  const reasonNote = event.reasonNote?.trim() || undefined

  if (!event.doneBy && !reasonLabel) return null

  const eventLabel = type === 'in' ? 'Check-in' : 'Check-out'

  return {
    completedBy: event.doneBy ? `${eventLabel} completed by ${event.doneBy}` : undefined,
    completedAt:
      event.doneBy && event.doneAt
        ? `on ${formatZonedDate(new Date(event.doneAt), timezone, 'MMM d, h:mm a')}`
        : undefined,
    reasonLabel: reasonLabel ? `Delay reason: ${reasonLabel}` : undefined,
    reasonNote: reasonLabel ? reasonNote : undefined,
  }
}
